import {
  TextField,
  Box,
  Stack,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  ToggleButton,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { axiosGetCall, axiosPatchCall } from 'src/services/apisCall';
import { renderErrorMessage, renderSuccessMessage } from '../../../lib/toastMessage';
import dayjs from 'dayjs';
import { LoadingButton } from '@mui/lab';
import Logger from '../../../lib/Logger';
import Iconify from '../../../components/iconify';
import { set } from 'lodash';

const logger = new Logger('asetting');

const requestList = [
  { label: 'Self', value: 'U' },
  { label: 'Downline', value: 'D' },
  { label: 'Hierarchy', value: 'H' },
];

const dndStatusList = [
  { label: 'On', value: '1' },
  { label: 'Off', value: '0' },
];

const manipulationFactorList = [
  { label: 'On (maximum)', value: 'true' },
  { label: 'Off (9x)', value: 'false' },
];

const Cutting = ({ user }) => {
  const inputSx = {
    color: 'grey.900',
    borderColor: 'grey.700',
    borderRadius: '6px',
  };

  const [answerPercent, setAnswerPercent] = useState(0);
  const [answerPercentRequestFor, setAnswerPercentRequestFor] = useState('U');
  const [dndStatusRequestFor, setDndStatusRequestFor] = useState('U');
  const [dndStatus, setDndStatus] = useState('0');
  const [startingRange, setStartingRange] = useState(0);
  const [endingRange, setEndingRange] = useState(0);
  const [startCuttingPercentage, setStartCuttingPercentage] = useState(0);
  const [endCuttingPercentage, setEndCuttingPercentage] = useState(0);
  const [cuttingRequestFor, setCuttingRequestFor] = useState('U');
  const [mockAnswer, setMockAnswer] = useState(0);

  const [answerPercentLoader, setAnswerPercentLoader] = useState(false);
  const [dndLoader, setDndLoader] = useState(false);
  const [load, setLoad] = useState(false);
  const [cuttingLoader, setCuttingLoader] = useState(false);
  const [cuttingToggle, setCuttingToggle] = useState('api');
  const [manipulationFactorRequestFor, setManipulationFactorRequestFor] = useState('U');
  const [manipulationFactor, setManipulationFactor] = useState('false');
  const [defaultCuttingRequestFor, setDefaultCuttingRequestFor] = useState('U');
  const [defaultCutting, setDefaultCutting] = useState(true);
  const [defaultCuttingLoader, setDefaultCuttingLoader] = useState(false);

  const updateDndStatus = async () => {
    try {
      setDndLoader(true);
      const payload = {
        userId: user?.voiceInfo?.userId,
        DNDFilterStatus: dndStatus,
        action: 'changeUserDNDFilterStatus',
        requestFor: 'U',
      };

      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = dndStatusRequestFor;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      setDndLoader(false);
      renderSuccessMessage('Success');
    } catch (error) {
      logger.error(error);
      setDndLoader(false);
      renderErrorMessage(error.message);
    }
  };

  const updateCuttingPercentage = async () => {
    try {
      if (parseInt(startCuttingPercentage) > parseInt(endCuttingPercentage)) {
        return renderErrorMessage('Start Cutting Percentage must be less than End Cutting Percentage');
      }

      if (
        parseInt(startCuttingPercentage) === parseInt(endCuttingPercentage) &&
        parseInt(startCuttingPercentage) !== 0
      ) {
        return renderErrorMessage('Start Cutting Percentage and End Cutting Percentage not be same');
      }

      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'setCutting',
        startingRange: parseInt(startingRange),
        endingRange: parseInt(endingRange),
        startCuttingPercentage: parseInt(startCuttingPercentage),
        endCuttingPercentage: parseInt(endCuttingPercentage),
        cuttingType: cuttingToggle,
        mockToAnswer: mockAnswer,
        requestFor: 'U',
      };

      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = cuttingRequestFor;
      }

      setCuttingLoader(true);
      await axiosPatchCall('updateProfileSetting', payload);
      setCuttingLoader(false);
      fetchSettingDetails(cuttingToggle);
      renderSuccessMessage('Success');
    } catch (error) {
      logger.error(error);
      setCuttingLoader(false);
      renderErrorMessage(error.message);
    }
  };

  const updateAnsweringPercentage = async () => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        answeringPercentage: answerPercent,
        action: 'setAnswering',
        requestFor: 'U',
      };

      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = answerPercentRequestFor;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      setDndLoader(false);
      renderSuccessMessage('Success');
    } catch (error) {
      logger.error(error);
      setAnswerPercentLoader(false);
      renderErrorMessage(error.message);
    }
  };

  const handleReset = async (type) => {
    let payload = {
      userId: user?.voiceInfo?.userId,
      action: 'resetSetting',
      resetActionType: '',
      requestFor: 'U',
    };

    if (type === 'dndStatus') {
      payload.resetActionType = 'changeUserDNDFilterStatus';
      payload.requestFor = dndStatusRequestFor;
    }

    if (type === 'answerPercentage') {
      payload.resetActionType = 'setAnswering';
      payload.requestFor = answerPercentRequestFor;
    }

    if (type === 'cutting') {
      payload.resetActionType = 'setCutting';
      payload.requestFor = cuttingRequestFor;
      payload.cuttingType = cuttingToggle;
    }
    if (type === 'manipulationFactor') {
      payload.resetActionType = 'setManipulationFactor';
      payload.requestFor = manipulationFactorRequestFor;
    }
    if (type === 'defaultCutting') {
      payload.resetActionType = 'updateDefaultCutting';
      payload.requestFor = defaultCuttingRequestFor;
    }
    try {
      await axiosPatchCall('updateProfileSetting', payload);
      renderSuccessMessage(`Success`);
      setLoad((prev) => !prev);
    } catch (error) {
      logger.error(error);
      setAnswerPercentLoader(false);
      renderErrorMessage(error.message);
    }
  };

    const updateManipulationFactor = async () => {
    try {
      const payload = {
        userId: user?.voiceInfo?.userId,
        status: manipulationFactor,
        action: 'setManipulationFactor',
        requestFor: 'U',
      };

      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = dndStatusRequestFor;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      console.log(payload);
      renderSuccessMessage('Success');
    } catch (error) {
      logger.error(error);
      renderErrorMessage(error.message);
    }
  };

  const updateDefaultCutting = async () => {
    try {
      setDefaultCuttingLoader(true);
      const payload = {
        userId: user?.voiceInfo?.userId,
        action: 'updateDefaultCutting',
        status:defaultCutting,
        requestFor: 'U',
      };

      if (user?.voiceInfo?.userType === 'reseller') {
        payload.requestFor = defaultCuttingRequestFor;
      }
      await axiosPatchCall('updateProfileSetting', payload);
      setDefaultCuttingLoader(false);
      renderSuccessMessage('Success');
    } catch (error) {
      logger.error(error);
      setDefaultCuttingLoader(false);
      renderErrorMessage(error.message);
    }
  };

  const handleSubmit = async (type) => {
    if (type === 'dndStatus') {
      await updateDndStatus();
    }

    if (type === 'answerPercentage') {
      await updateAnsweringPercentage();
    }

    if (type === 'cutting') {
      await updateCuttingPercentage();
    }
    if (type === 'manipulationFactor') {
       if (manipulationFactor === 'false') {
        await handleReset('manipulationFactor')
        return;
       }
      await updateManipulationFactor();
    }
    if (type === 'defaultCutting') {
      await updateDefaultCutting();
    }
  };

  const fetchSettingDetails = async (cuttingToggle) => {
    try {
      const params = { requestUserId: user?.voiceInfo?.userId, requestName: 'all', cuttingType: cuttingToggle };
      const { data = {} } = await axiosGetCall('getUserSettingsInfo', { ...params });
      const {
        data: { answerPercentage = 0 },
      } = await axiosGetCall('getUserSettingsInfo', {
        requestName: 'answerPer',
        requestUserId: user?.voiceInfo?.userId,
      });
      setAnswerPercent(answerPercentage);

      const {
        data: { startingRange, endingRange, startCuttingPercentage, endCuttingPercentage, mockToAnswer, type },
      } = await axiosGetCall('getUserSettingsInfo', {
        requestName: 'setCutting',
        requestUserId: user?.voiceInfo?.userId,
        cuttingType: cuttingToggle,
      });
      setStartCuttingPercentage(startCuttingPercentage);
      setStartingRange(startingRange);
      setEndingRange(endingRange);
      setEndCuttingPercentage(endCuttingPercentage);
      setMockAnswer(mockToAnswer);
      // setCuttingToggle(type);
      const { DNDFilterStatus } = data;
      setDndStatus(DNDFilterStatus);

      const {data: {manipulationFactor},
      } = await axiosGetCall('getUserSettingsInfo', {
        requestName: 'getManipulationFactor',
        requestUserId: user?.voiceInfo?.userId,
      });
      setManipulationFactor(manipulationFactor || 'false');

      const { data: { defaultCutting: fetchedDefaultCutting } = {} } = await axiosGetCall('getUserSettingsInfo', {
        requestName: 'getDefaultCutting',
        requestUserId: user?.voiceInfo?.userId,
      }).catch(() => ({ data: {} }));
      setDefaultCutting(fetchedDefaultCutting || true);

    } catch (error) {
      logger.error(error);
    }
  };

  useEffect(() => {
    fetchSettingDetails(cuttingToggle);
    // eslint-disable-next-line
  }, [load, cuttingToggle]);

  return (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '16px',
          mt: '10px',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            mb: '15px',
            border: '0.5px dashed',
            borderColor: 'gray.400',
            borderRadius: '7px',
            padding: '12px',
            paddingTop: '14px',
          }}
        >
          <TextField
            fullWidth
            id="outlined-basic"
            label="Answer Percentage"
            type="number"
            variant="outlined"
            InputProps={{
              sx: inputSx,
            }}
            value={answerPercent}
            onChange={(e) => setAnswerPercent(e.target.value)}
            size="small"
          />
          {user?.voiceInfo?.userType === 'reseller' && (
            <Stack
              gap={2}
              direction={'row'}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="request-select">Request For</InputLabel>
                <Select
                  labelId="request-select"
                  id="request-select"
                  value={answerPercentRequestFor || ''}
                  onChange={(e) => setAnswerPercentRequestFor(e?.target?.value)}
                  label="Request For"
                  size="small"
                  displayEmpty
                >
                  {requestList.map(({ label, value }) => (
                    <MenuItem key={label} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction={'row'} gap={1}>
              <IconButton onClick={() => handleReset('answerPercentage')}>
                <Iconify icon="ix:reset" />
              </IconButton>
              <LoadingButton
                loading={answerPercentLoader}
                variant="contained"
                sx={{ width: '100px' }}
                onClick={() => handleSubmit('answerPercentage')}
              >
                Submit
              </LoadingButton>
            </Stack>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            mb: '15px',
            border: '0.5px dashed',
            borderColor: 'gray.400',
            borderRadius: '7px',
            padding: '12px',
            paddingTop: '14px',
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="request-select">Dnd Status</InputLabel>
            <Select
              labelId="request-select"
              id="request-select"
              value={dndStatus || ''}
              onChange={(e) => setDndStatus(e?.target?.value)}
              label="Dnd Status"
              size="small"
              displayEmpty
            >
              {dndStatusList.map(({ label, value }) => (
                <MenuItem key={label} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          {user?.voiceInfo?.userType === 'reseller' && (
            <Stack
              gap={2}
              direction={'row'}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="request-select">Request For</InputLabel>
                <Select
                  labelId="request-select"
                  id="request-select"
                  value={dndStatusRequestFor || ''}
                  onChange={(e) => setDndStatusRequestFor(e?.target?.value)}
                  label="Request For"
                  size="small"
                  displayEmpty
                >
                  {requestList.map(({ label, value }) => (
                    <MenuItem key={label} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}

          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction={'row'} gap={1}>
              <IconButton onClick={() => handleReset('dndStatus')}>
                <Iconify icon="ix:reset" />
              </IconButton>
              <LoadingButton
                loading={dndLoader}
                variant="contained"
                sx={{ width: '100px' }}
                onClick={() => handleSubmit('dndStatus')}
              >
                Submit
              </LoadingButton>
            </Stack>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '6px',
            mb: '15px',
            border: '0.5px dashed',
            borderColor: 'gray.400',
            borderRadius: '7px',
            padding: '12px',
            paddingTop: '14px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              gap: '6px',
              mb: '15px',
            }}
          >
            <ToggleButton
              sx={{ border: 'none' }}
              value="api"
              selected={cuttingToggle === 'api'}
              onChange={() => setCuttingToggle('api')}
            >
              API
            </ToggleButton>
            <ToggleButton
              sx={{ border: 'none' }}
              value="regular"
              selected={cuttingToggle === 'regular'}
              onChange={() => setCuttingToggle('regular')}
            >
              Regular
            </ToggleButton>
          </Box>
          <Box>
            <Box
              sx={{
                display: 'flex',
                gap: '6px',
                mb: '15px',
              }}
            >
              <TextField
                fullWidth
                id="outlined-basic"
                label="Starting Range"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={startingRange}
                onChange={(e) => setStartingRange(e.target.value)}
                size="small"
              />

              <TextField
                fullWidth
                id="outlined-basic"
                label="Ending Range"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={endingRange}
                onChange={(e) => setEndingRange(e.target.value)}
                size="small"
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                gap: '6px',
                mb: '15px',
              }}
            >
              <TextField
                fullWidth
                id="outlined-basic"
                label="Start Cutting Percentage"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={startCuttingPercentage}
                onChange={(e) => setStartCuttingPercentage(e.target.value)}
                size="small"
              />
              <TextField
                fullWidth
                id="outlined-basic"
                label="End Cutting Percentage"
                type="number"
                variant="outlined"
                InputProps={{
                  sx: inputSx,
                }}
                value={endCuttingPercentage}
                onChange={(e) => setEndCuttingPercentage(e.target.value)}
                size="small"
              />
            </Box>
          </Box>

          <Stack width={'100%'} direction={'row'} alignItems={'center'}>
            {user?.voiceInfo?.userType === 'reseller' && (
              <Stack
                gap={2}
                direction={'row'}
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  width: '100%',
                  mb: '10px',
                }}
              >
                <FormControl fullWidth>
                  <InputLabel id="request-select">Request For</InputLabel>
                  <Select
                    labelId="request-select"
                    id="request-select"
                    value={cuttingRequestFor || ''}
                    onChange={(e) => setCuttingRequestFor(e?.target?.value)}
                    label="Request For"
                    size="small"
                    displayEmpty
                  >
                    {requestList.map(({ label, value }) => (
                      <MenuItem key={label} value={value}>
                        {label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Stack>
            )}
          </Stack>

          <Stack width={'100%'} direction={'row'} alignItems={'center'}>
            {/* {user?.voiceInfo?.userType === 'reseller' && ( */}
            <Stack
              gap={2}
              direction={'row'}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '80%',
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="mock-select">Mock to answer</InputLabel>
                <Select
                  labelId="mock-select"
                  id="mock-select"
                  value={mockAnswer}
                  onChange={(e) => setMockAnswer(e?.target?.value)}
                  label="Mock to answer"
                  size="small"
                >
                  <MenuItem value={1}>Yes</MenuItem>
                  <MenuItem value={0}>No</MenuItem>
                </Select>
              </FormControl>
            </Stack>
            {/* )} */}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Stack direction={'row'} gap={1}>
                <IconButton onClick={() => handleReset('cutting')}>
                  <Iconify icon="ix:reset" />
                </IconButton>
                <LoadingButton
                  loading={cuttingLoader}
                  variant="contained"
                  sx={{ width: '100px' }}
                  onClick={() => handleSubmit('cutting')}
                >
                  Submit
                </LoadingButton>
              </Stack>
            </Box>
          </Stack>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            mb: '15px',
            border: '0.5px dashed',
            borderColor: 'gray.400',
            borderRadius: '7px',
            padding: '12px',
            paddingTop: '14px',
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="request-select">Manipulation Factor Custom</InputLabel>
            <Select
              labelId="request-select"
              id="request-select"
              value={manipulationFactor || ''}
              onChange={(e) => setManipulationFactor(e?.target?.value)}
              label="Manipulation Factor Custom"
              size="small"
              displayEmpty
            >
              {manipulationFactorList.map(({ label, value }) => (
                <MenuItem key={label} value={value}>
                  {label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {user?.voiceInfo?.userType === 'reseller' && (
            <Stack
              gap={2}
              direction={'row'}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="request-select">Request For</InputLabel>
                <Select
                  labelId="request-select"
                  id="request-select"
                  value={manipulationFactorRequestFor || ''}
                  onChange={(e) => setManipulationFactorRequestFor(e?.target?.value)}
                  label="Request For"
                  size="small"
                  displayEmpty
                >
                  {requestList.map(({ label, value }) => (
                    <MenuItem key={label} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction={'row'} gap={1}>
              <IconButton 
              onClick={() => handleReset('manipulationFactor')}
              >
                <Iconify icon="ix:reset" />
              </IconButton>
              <LoadingButton
                loading={answerPercentLoader}
                variant="contained"
                sx={{ width: '100px' }}
                onClick={() => handleSubmit('manipulationFactor')}
              >
                Submit
              </LoadingButton>
            </Stack>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            gap: '6px',
            mb: '15px',
            border: '0.5px dashed',
            borderColor: 'gray.400',
            borderRadius: '7px',
            padding: '12px',
            paddingTop: '14px',
          }}
        >
          <FormControl fullWidth>
            <InputLabel id="default-cutting-select">Default Campaign Cutting (25%–30%)</InputLabel>
            <Select
              labelId="default-cutting-select"
              id="default-cutting-select"
              value={String(defaultCutting)}
              onChange={(e) => setDefaultCutting(e?.target?.value === 'true')}
              label="Default Campaign Cutting (25%–30%)"
              size="small"
              displayEmpty
            >
              <MenuItem value="true">On</MenuItem>
              <MenuItem value="false">Off</MenuItem>
            </Select>
          </FormControl>
          {user?.voiceInfo?.userType === 'reseller' && (
            <Stack
              gap={2}
              direction={'row'}
              sx={{
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <FormControl fullWidth>
                <InputLabel id="default-cutting-request-select">Request For</InputLabel>
                <Select
                  labelId="default-cutting-request-select"
                  id="default-cutting-request-select"
                  value={defaultCuttingRequestFor || ''}
                  onChange={(e) => setDefaultCuttingRequestFor(e?.target?.value)}
                  label="Request For"
                  size="small"
                  displayEmpty
                >
                  {requestList.map(({ label, value }) => (
                    <MenuItem key={label} value={value}>
                      {label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Stack>
          )}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Stack direction={'row'} gap={1}>
              <IconButton onClick={() => handleReset('defaultCutting')}>
                <Iconify icon="ix:reset" />
              </IconButton>
              <LoadingButton
                loading={defaultCuttingLoader}
                variant="contained"
                sx={{ width: '100px' }}
                onClick={() => handleSubmit('defaultCutting')}
              >
                Submit
              </LoadingButton>
            </Stack>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default Cutting;
